import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  emptyText: {
    padding: theme.spacing(0.5, 0),
    fontStyle: 'italic',
    color: theme.palette.text.secondary
  }
}));

export const NoCostRatesMessage = () => {
  const classes = useStyles();

  return (
    <>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesDialogNoCostOverridesSet"
      >
        <FormattedMessage id="projectCostOverrides.dialog.noCostOverridesSet" />
      </Typography>
      <Typography
        variant="body2"
        className={classes.emptyText}
        data-qe-id="ProjectCostOverridesDialogChooseToDefineOverrides"
      >
        <FormattedMessage id="projectCostOverrides.dialog.chooseToDefineOverrides" />
      </Typography>
    </>
  );
};

export default NoCostRatesMessage;
